export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'c5378750-03d4-48b4-8f45-24bb479636f6',
    },
    customers_auth: {
      clientId: '1fff89f2-7920-4a48-9351-f2a8dcef7b17',
    }
  },
  apiConfig: {
    IdentityAPI: {
      endpoint: "https://bc-id-api-dev-aebfhbgdb6bmb0db.northeurope-01.azurewebsites.net",
      scopes: {
        read: ["https://bizcombo.onmicrosoft.com/1de6bd1c-2d7e-4d72-a620-47a7021a0e7b/User.Read"],
        write: ["https://bizcombo.onmicrosoft.com/1de6bd1c-2d7e-4d72-a620-47a7021a0e7b/User.ReadWrite"]
      }
    },
    corporateAPI: {
      endpoint: 'https://bc-corp-api-dev-eac3frambbf6echg.northeurope-01.azurewebsites.net'
    },
    // Billing / Licensing module (BizCombo_LAC). endpoint = the licensing API base (incl. /api/licensing/v1).
    billingAPI: {
      endpoint: 'https://dev-billing-api.bizcombotech.com/api/licensing/v1',
      environment: 'Dev',
      // Local-only fallback (localhost/apex). Leave empty so the real subdomain drives the org;
      // for local dev pass ?org=<code> instead of hardcoding a tenant here.
      devOrgCode: ''
    },
    legacyInvoicingApi : {
      endpoint: 'https://bc-inv-legacy-api-dev-hce6ewedgzdrf2df.northeurope-01.azurewebsites.net'
    },
    customers_msal: {
      scopes: {
        write: ["https://bccustomers.onmicrosoft.com/B2C_1_SignIn/1fff89f2-7920-4a48-9351-f2a8dcef7b17/Customer.ReadWrite"]
      },
      token_scopes: {
        write: ["https://bccustomers.onmicrosoft.com/11e350d3-c228-45ed-b80d-bd194728efa4/Customer.ReadWrite"]
      }
    },
    scopes: ['https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read'],
    uri: 'https://fabrikamb2chello.azurewebsites.net/hello'
  },
  b2cPolicies: {
    names: {
      signUpSignIn: "B2C_1_SignUp_SignIn_v2",
      resetPassword: "B2C_1_Pass_Reset_v2",
      editProfile: "B2C_1_Profile_Edit_v2"
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://bizcombo.b2clogin.com/bizcombo.onmicrosoft.com/B2C_1_SignUp_SignIn_v2',
      },
      resetPassword: {
        authority: 'https://bizcombo.b2clogin.com/bizcombo.onmicrosoft.com/B2C_1_Pass_Reset_v2'
      },
      editProfile: {
        authority: "https://bizcombo.b2clogin.com/bizcombo.onmicrosoft.com/B2C_1_Profile_Edit_v2"
      }
    },
    authorityDomain: "bizcombo.b2clogin.com"
  },
  // Customer Onboarding policies
  b2cCustomerPolicies: {
    names: {
      individualSignUpPolicyId: "B2C_1_SignUp_Individual",
      businessSignUpPolicyId: "B2C_1_SignUp_Business",
      signInPolicyId: "B2C_1_Customer_SignIn"
    },
    authorities: {
      individualSignUpPolicyId: {
        authority: 'https://bccustomers.b2clogin.com/bccustomers.onmicrosoft.com/B2C_1_SignUp_Individual',
      },
      businessSignUpPolicyId: {
        authority: 'https://bccustomers.b2clogin.com/bccustomers.onmicrosoft.com/B2C_1_SignUp_Business'
      },
      signInPolicyId: {
        authority: "https://bccustomers.b2clogin.com/bccustomers.onmicrosoft.com/B2C_1_SignIn"
      }
    },
    authorityDomain: "bccustomers.b2clogin.com"
  },
  VERSION: '0.0062',
  invoicing_api: 'https://bc-inv-api-dev-f7guc0dyhyf8hccm.northeurope-01.azurewebsites.net/api/'
};

//Identity local- https://localhost:7036
//Corporate local - https://localhost:7008
// Legacy local - https://localhost:7027

//Identity prod - https://bc-id-api.azurewebsites.net
//Corporate prod - https://bc-corp-api.azurewebsites.net
// Legacy dev = https://bc-inv-api-dev-f7guc0dyhyf8hccm.northeurope-01.azurewebsites.net
